import {Article, ArticleState} from '../interfaces';

export const mutations = {
  SET_ARTICLES(state: ArticleState, articles: Article[]): void {
    state.articles = articles;
  },
};
